import axiosInstance from "../axiosInstance";
import { ApiResponse } from "@/types/apiResponse";

export interface Quota {
  used: number;
  limit: number;
}

export interface Entitlements {
  pass: boolean;
  mocks: Quota | null;
  contests: Quota | null;
  solutions_per_attempt: number | null;
}

export interface PassPricing {
  amount_paise: number;
  list_paise: number;
  /** Null once the launch window closes. */
  offer: { label: string; ends_at: string } | null;
}

export interface PassStatus {
  active: boolean;
  cycle: string;
  expires_at: string | null;
  purchased_at: string | null;
  pricing: PassPricing;
  /** Present on GET /pass/me; absent on the verify response. */
  entitlements?: Entitlements;
}

export interface PassOrder {
  order_id: string;
  amount_paise: number;
  currency: string;
  key_id: string;
}

export const passKey = ["pass", "me"] as const;
export const passPricingKey = ["pass", "price"] as const;

/** Public — the pricing page and the nav offer work signed out. */
export const getPassPricing = async (): Promise<ApiResponse<PassPricing>> => {
  const res = await axiosInstance.get("/pass/price");
  return res.data;
};

export const getMyPass = async (): Promise<ApiResponse<PassStatus>> => {
  const res = await axiosInstance.get("/pass/me");
  return res.data;
};

export const createPassOrder = async (): Promise<ApiResponse<PassOrder>> => {
  const res = await axiosInstance.post("/pass/order");
  return res.data;
};

export const verifyPassPayment = async (payload: {
  razorpay_order_id: string;
  razorpay_payment_id: string;
  razorpay_signature: string;
}): Promise<ApiResponse<PassStatus>> => {
  const res = await axiosInstance.post("/pass/verify", payload);
  return res.data;
};

export const PASS_CYCLE_LABEL = "GATE 2027";

export const rupees = (paise: number) => Math.round(paise / 100);
